export interface OAuthClientRegistrationRequest {
  token: string;
  redirectUri: string;
}

export interface OAuthClientCredentials {
  clientId: string;
  clientSecret: string;
}

export interface OAuthClientRegistrationResponse {
  credentials: OAuthClientCredentials;
}

/**
 * Validation messages returned by the client registration endpoint in a 400
 * response, in the order the backend checks them.
 */
export enum OAuthClientRegistrationError {
  INVALID_URI = "'redirectUri' needs to be a correct URI",
  HTTPS_REQUIRED = "The URI needs to be of 'https' scheme",
  QUERY_NOT_ALLOWED = 'URI cannot contain any query',
  INCORRECT_TOKEN = 'Incorrect token',
  INVALID_TOKEN = 'Token is invalid',
}
